// extracted by mini-css-extract-plugin
export var askAiIcon = "_mj-j";
export var category = "_mj-9";
export var categoryHeader = "_mj-e";
export var container = "_mj-0";
export var group = "_mj-a";
export var groupItems = "_mj-f";
export var groupSeparator = "_mj-k";
export var loading = "_mj-1";
export var noResults = "_mj-3";
export var placeholder = "_mj-2";
export var resultContent = "_mj-5";
export var resultIcon = "_mj-c";
export var resultItem = "_mj-g";
export var resultMeta = "_mj-8";
export var resultSubtitle = "_mj-7";
export var resultSuffix = "_mj-i";
export var resultTitle = "_mj-6";
export var resultsList = "_mj-4";
export var searchGroup = "_mj-d";
export var selected = "_mj-h";
export var subgroup = "_mj-b";